import { Col } from "react-bootstrap";

export const ProjectCard = ({ title, description, imgUrl , link}) => {
  return (
    <Col size={12} sm={6} md={4}>
      <a href={link} target='_blank' rel="noreferrer">
        <div className='proj-imgbx'>
          <img src={imgUrl} alt='img' width={100} height={100}/>
          <div className='proj-txtx'>
            <h4>{title}</h4>
            <span>{description}</span>
          </div>
        </div>
      </a>
    </Col>
  );
};
